export default "__VITE_ASSET__3hJd19ec__"